module.exports = __webpack_public_path__ + "static/media/siddharth-yelahanka-trip-banner.6099b046.jpg";